import { DataBean } from "../DataBean";

export class AdquisitionBeneficiary extends DataBean {

    public async getProjectBeneficiaryCatalogPorPropiedadesRender(props:any,rows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getProjectBeneficiaryCatalogPorPropiedadesRender_java.util.Map_Number", [props,rows]);
    }


}
